<template>
<!-- eslint-disable max-len -->
<div class="btn-white cash">
  <span class="currency-nav" :style="game.cashTopBarValueStyle || {}">{{ currentCash | currency }}</span>
</div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      currentCash: 0
    };
  },
  computed: {
    ...mapGetters([
      'game',
      'playerGroupRole',
      'teamDecisionBeginCash',
      'displayCash',
      'currentState',
      'dashboardState',
      'individualDecisionState',
      'resultsState',
      'teamDecisionState'
    ]),
    cash() {
      const oldMetricStates = [
        this.individualDecisionState,
        this.teamDecisionState,
        this.dashboardState
      ];

      if (this.playerGroupRole.useRoleCash) {
        return this.displayCash;
      }
      const showOldMetrics = oldMetricStates.includes(this.$route.path);
      if (showOldMetrics) return this.teamDecisionBeginCash;
      // display cash accounts for metric splitting across challenges
      return this.displayCash;
    }
  },
  created() {
    this.currentCash = this.cash;
  }
};
</script>

<style lang="scss" scoped>
.cash {
  top: 0;
  left: 0;
  margin: 0;
  font-size: 65px;
  font-weight: bold;
  height: 90px;
  width: 300px;
  background-color: transparent;
  display: flex;
  flex-flow: row;
  align-items: center;
  justify-content: flex-end;
}
.currency-nav {
  color: white;
  font-size: 42px;
  height: 60px;
  margin-top: 20px;
  margin-right: 18px;
  text-align: right;
}
.currency-nav::before {
  content: '$';
  font-size: 27px;
  vertical-align: top;
}
</style>



// WEBPACK FOOTER //
// src/components/game/ui/CashNavbar.vue